/* QEA theme — progressive enhancement. Pages are fully readable without JS. */
(function () {
  "use strict";
  var root = document.documentElement;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  root.classList.add("js");

  // Reveal on scroll
  var reveals = [].slice.call(document.querySelectorAll(".reveal"));
  function showAll() { reveals.forEach(function (el) { el.classList.add("in"); }); }
  if (reduce || !("IntersectionObserver" in window)) { showAll(); }
  else {
    var io = new IntersectionObserver(function (es, o) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); o.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
    window.addEventListener("load", function () { setTimeout(showAll, 2500); });
  }

  // Stat count-up
  [].slice.call(document.querySelectorAll(".stat-num[data-count]")).forEach(function (el) {
    function run() {
      var t = parseInt(el.getAttribute("data-count"), 10); if (isNaN(t)) return;
      var pct = el.querySelector(".pct"); var suf = pct ? pct.outerHTML : "";
      if (reduce) { el.innerHTML = t + suf; return; }
      var start = null;
      function tick(ts) { if (start === null) start = ts; var p = Math.min((ts - start) / 1400, 1);
        var e = p === 1 ? 1 : 1 - Math.pow(2, -10 * p); el.innerHTML = Math.round(e * t) + suf; if (p < 1) requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    }
    if (!("IntersectionObserver" in window)) { run(); return; }
    var io2 = new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { run(); o.unobserve(e.target); } }); }, { threshold: 0.6 });
    io2.observe(el);
  });

  // Sticky buy bar
  var bar = document.getElementById("qeaBuybar");
  if (bar) {
    function onScroll() { var show = window.scrollY > 500; bar.classList.toggle("show", show); bar.setAttribute("aria-hidden", show ? "false" : "true"); }
    window.addEventListener("scroll", onScroll, { passive: true }); onScroll();
  }

  // Product gallery (thumbnails + arrows)
  var gMain = document.getElementById("galleryMain");
  var thumbs = [].slice.call(document.querySelectorAll(".thumb"));
  var coverBadges = document.getElementById("coverBadges");
  if (gMain && thumbs.length) {
    var gi = 0;
    function show(i) {
      gi = (i + thumbs.length) % thumbs.length; var b = thumbs[gi];
      var s = b.getAttribute("data-src"); if (s) gMain.src = s;
      thumbs.forEach(function (t) { t.classList.remove("is-active"); }); b.classList.add("is-active");
      if (coverBadges) coverBadges.style.display = gi === 0 ? "" : "none"; // badges only on the cover
      b.scrollIntoView({ block: "nearest", inline: "nearest" });
    }
    thumbs.forEach(function (b, i) { b.addEventListener("click", function () { show(i); }); });
    var p = document.querySelector(".gallery-prev"), n = document.querySelector(".gallery-next");
    if (p) p.addEventListener("click", function () { show(gi - 1); });
    if (n) n.addEventListener("click", function () { show(gi + 1); });
  }

  // Subtle parallax drift on tall media (luxury feel)
  var parEls = [].slice.call(document.querySelectorAll(".ben-perform-media img, .ben-overlay-media img"));
  if (!reduce && parEls.length && "requestAnimationFrame" in window) {
    var parTick = false;
    function parUpdate() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      parEls.forEach(function (img) {
        var fig = img.parentElement;
        var r = fig.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var pr = (vh - r.top) / (vh + r.height);
        pr = pr < 0 ? 0 : pr > 1 ? 1 : pr;
        var shift = -20 + pr * 14; // stays within the 22% image overflow
        img.style.transform = "translate3d(0," + shift.toFixed(2) + "%,0)";
      });
      parTick = false;
    }
    window.addEventListener("scroll", function () { if (!parTick) { requestAnimationFrame(parUpdate); parTick = true; } }, { passive: true });
    window.addEventListener("resize", function () { if (!parTick) { requestAnimationFrame(parUpdate); parTick = true; } }, { passive: true });
    parUpdate();
  }
})();

/* ============================================================
   Shopify AJAX cart drawer
   - Opens on "Add to cart" (product form) and on the header cart icon.
   - Reads the REAL Shopify cart (/cart.js), so prices/discounts are true.
   - Checkout submits to Shopify's real checkout (/cart, name="checkout").
   - Does NOT fake discounts: the "15% off" line only shows when Shopify
     actually applies a discount (set one up in Admin → Discounts).
   ============================================================ */
(function () {
  "use strict";
  if (!window.fetch) return; // graceful: links fall back to /cart + native submit

  var drawer, backdrop, listEl, subEl, perksEl, protectEl, discRow, discEl, shipEl, totalEl;

  // Optional Shipping Protection (a real $6 Shopify product; variant id set in theme settings).
  var SP = window.QEA_SHIPPROT || {};
  var SP_ENABLED = !!SP.enabled && !!SP.variantId;
  var SP_ID = SP.variantId ? Number(SP.variantId) : 0;
  var SP_OFF_KEY = "qea_shipprot_off";
  var spBusy = false;
  var spAddFailed = false;
  function spOptedOut() { try { return localStorage.getItem(SP_OFF_KEY) === "1"; } catch (e) { return false; } }
  function spSetOptOut(v) { try { v ? localStorage.setItem(SP_OFF_KEY, "1") : localStorage.removeItem(SP_OFF_KEY); } catch (e) {} }
  function isProt(i) { return SP_ID && Number(i.variant_id) === SP_ID; }

  function fmt(cents) {
    var n = (cents || 0) / 100;
    return "$" + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function thumb(url) {
    if (!url) return "";
    return url.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, "_160x$1$2");
  }

  function build() {
    backdrop = document.createElement("div");
    backdrop.className = "cart-backdrop";
    backdrop.addEventListener("click", close);

    drawer = document.createElement("aside");
    drawer.className = "cart-drawer";
    drawer.setAttribute("role", "dialog");
    drawer.setAttribute("aria-label", "Your cart");
    drawer.setAttribute("aria-hidden", "true");
    drawer.innerHTML =
      '<div class="cart-head"><h2>Your cart</h2>' +
      '<button class="cart-close" type="button" aria-label="Close cart"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
      '<div class="cart-list"></div>' +
      '<div class="cart-foot">' +
        '<div class="cart-countdown"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9.5V13l2.4 1.4M9 3h6"/></svg> Offer ends in <strong class="tnum" data-oc-time>10:00</strong></div>' +
        '<div class="cart-perks"></div>' +
        '<div class="cart-protect"></div>' +
        '<div class="cart-totals">' +
          '<div class="cart-row"><span>Subtotal</span><span class="cart-sub-val tnum">$0.00</span></div>' +
          '<div class="cart-row cart-discount-row" hidden><span class="cart-disc-label">Discount</span><span class="cart-disc-val tnum">-$0.00</span></div>' +
          '<div class="cart-row"><span>Shipping</span><span class="cart-ship-val">&mdash;</span></div>' +
          '<div class="cart-row cart-total-row"><span>Total</span><strong class="cart-total-val tnum">$0.00</strong></div>' +
        '</div>' +
        '<p class="cart-note">Taxes calculated at secure checkout. <a href="#" class="cart-terms-link" data-subs-open>Subscription terms</a></p>' +
        '<p class="cart-hardship">Minimum term may be waived at our discretion for financial hardship, medical, or other significant circumstances &mdash; email qeacoffee123@gmail.com.</p>' +
        '<a href="/checkout" class="btn btn-amber btn-block btn-lg cart-checkout">Checkout</a>' +
        '<p class="cart-consent">By checking out you agree to the <a href="#" data-subs-open>terms &amp; agreement</a>.</p>' +
        '<div class="cart-express-slot"></div>' +
      '</div>';

    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);

    // Relocate Shopify's real express-checkout buttons (Apple Pay / Shop Pay / PayPal / GPay) under Checkout.
    // Show the top wallet button; collapse the rest behind a "More payment options" link so they don't fill the cart.
    var express = document.getElementById("qeaExpressCheckout");
    var slot = drawer.querySelector(".cart-express-slot");
    if (express && slot) {
      express.hidden = false;
      slot.appendChild(express);
    }
    listEl = drawer.querySelector(".cart-list");
    subEl = drawer.querySelector(".cart-sub-val");
    perksEl = drawer.querySelector(".cart-perks");
    protectEl = drawer.querySelector(".cart-protect");

    // Shipping-protection toggle (add/remove the real product, remember the choice)
    protectEl.addEventListener("click", function (e) {
      var t = e.target.closest("[data-sp-toggle]");
      if (!t || spBusy) return;
      var on = t.getAttribute("aria-checked") === "true";
      spBusy = true;
      if (on) { spSetOptOut(true); removeProtection(); }
      else { spSetOptOut(false); spAddFailed = false; addProtection(); }
    });
    discRow = drawer.querySelector(".cart-discount-row");
    discEl = drawer.querySelector(".cart-disc-val");
    shipEl = drawer.querySelector(".cart-ship-val");
    totalEl = drawer.querySelector(".cart-total-val");
    drawer.querySelector(".cart-close").addEventListener("click", close);

    var co = drawer.querySelector(".cart-checkout");
    if (co) co.addEventListener("click", function (e) { if (co.classList.contains("is-disabled")) e.preventDefault(); });

    // Quantity + remove (event delegation)
    listEl.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-cart-action]");
      if (!btn) return;
      var key = btn.getAttribute("data-id");
      var qty = parseInt(btn.getAttribute("data-qty"), 10) || 0;
      var a = btn.getAttribute("data-cart-action");
      var nq = a === "inc" ? qty + 1 : a === "dec" ? qty - 1 : 0;
      changeLine(key, Math.max(0, nq));
    });
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }

  function changeLine(key, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render);
  }

  function addProtection() {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: SP_ID, quantity: 1 }] })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () { spBusy = false; })
      .catch(function () { spBusy = false; spAddFailed = true; }); // bad/invalid variant id → stop retrying
  }
  function removeProtection() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var line = (c.items || []).filter(isProt)[0];
        if (!line) { spBusy = false; return fetchCart(); }
        return changeLine(line.key, 0).then(function () { spBusy = false; });
      })
      .catch(function () { spBusy = false; });
  }

  function renderProtect(hasItems, on) {
    if (!protectEl) return;
    if (!SP_ENABLED || !hasItems) { protectEl.innerHTML = ""; return; }
    protectEl.innerHTML =
      '<div class="sp-row">' +
        '<span class="sp-ico" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 2 4 5v6c0 5 3.4 8.6 8 10 4.6-1.4 8-5 8-10V5l-8-3z"/><path d="M9 12l2 2 4-4"/></svg></span>' +
        '<span class="sp-text">' +
          '<span class="sp-title">' + (SP.title || "Shipping Protection") + ' <span class="sp-price tnum">' + (SP.price || "$6.00") + '</span></span>' +
          '<span class="sp-desc">' + (SP.desc || "Covers your order against loss, damage, or theft in transit.") + '</span>' +
        '</span>' +
        '<button type="button" class="sp-switch" data-sp-toggle role="switch" aria-checked="' + (on ? "true" : "false") + '" aria-label="Shipping protection"><span class="sp-knob"></span></button>' +
      '</div>';
  }

  function render(c) {
    if (!drawer || !c) return;
    var allItems = c.items || [];
    var protInCart = allItems.some(isProt);
    var items = SP_ENABLED ? allItems.filter(function (i) { return !isProt(i); }) : allItems;

    // Always draw the toggle first (so it's visible even while an add is in flight),
    // then auto-apply when there are real items and the shopper hasn't opted out, or
    // auto-remove when the cart is emptied. addProtection/removeProtection re-fetch,
    // which re-renders. spAddFailed stops a retry loop if the variant id is wrong.
    renderProtect(items.length > 0, protInCart);
    if (SP_ENABLED && !spBusy) {
      if (items.length > 0 && !protInCart && !spOptedOut() && !spAddFailed) { spBusy = true; addProtection(); }
      else if (items.length === 0 && protInCart) { spBusy = true; removeProtection(); }
    }

    if (!items.length) {
      listEl.innerHTML = '<p class="cart-empty">Your cart is empty.<br><span>Free shipping + 30-day money-back guarantee on every order.</span></p>';
    } else {
      listEl.innerHTML = items.map(function (i) {
        var _alloc = i.selling_plan_allocation;
        // Subscription line shows the ACCURATE term for whichever plan is in the cart:
        //  • $1 trial   → bills $1 today (unit final price ~$1) → "$1 first month, then $28/mo, 3-month commitment"
        //  • flat plan  → "$25/mo, cancel anytime"
        // One-time items show the variant title.
        var plan = "";
        if (_alloc && _alloc.selling_plan) {
          var _unit = (i.final_price != null ? i.final_price : i.price);
          plan = _unit <= 500
            ? '<strong>$1 first month</strong> &middot; then $28/mo &middot; 3-month commitment <a class="cart-item-terms" href="#" data-subs-open>Terms</a>'
            : '<strong>$25/mo</strong> &middot; cancel anytime <a class="cart-item-terms" href="#" data-subs-open>Terms</a>';
        } else if (i.variant_title && i.variant_title !== "Default Title") {
          plan = i.variant_title;
        }
        return '<div class="cart-item">' +
          (i.image ? '<img class="cart-item-img" src="' + thumb(i.image) + '" alt="" />' : "") +
          '<div class="cart-item-main">' +
            '<div class="cart-item-top"><span class="cart-item-name">' + i.product_title + "</span>" +
            '<button class="cart-item-remove" data-cart-action="remove" data-id="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></div>' +
            (plan ? '<span class="cart-item-plan">' + plan + "</span>" : "") +
            '<div class="cart-item-bottom">' +
              '<div class="cart-qty">' +
                '<button data-cart-action="dec" data-id="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Decrease quantity" type="button">&minus;</button>' +
                "<span>" + i.quantity + "</span>" +
                '<button data-cart-action="inc" data-id="' + i.key + '" data-qty="' + i.quantity + '" aria-label="Increase quantity" type="button">+</button>' +
              "</div>" +
              (i.original_line_price > i.final_line_price
                ? '<span class="cart-item-price tnum"><s class="cart-item-was">' + fmt(i.original_line_price) + '</s> <span class="cart-item-now">' + fmt(i.final_line_price) + '</span></span>'
                : '<span class="cart-item-price tnum">' + fmt(i.final_line_price) + "</span>") +
            "</div>" +
          "</div>" +
        "</div>";
      }).join("");
    }

    var cnt = c.item_count || 0;
    var disc = c.total_discount || 0;
    subEl.textContent = fmt(c.original_total_price != null ? c.original_total_price : c.items_subtotal_price);
    if (discRow) discRow.hidden = disc <= 0;
    if (discEl) discEl.textContent = "-" + fmt(disc);
    if (shipEl) shipEl.textContent = cnt >= 1 ? "FREE" : "—";
    if (totalEl) totalEl.textContent = fmt(c.total_price);

    // Name the discount row after the real Shopify discount (code or automatic), not a hardcoded promo.
    var discLabelEl = drawer.querySelector(".cart-disc-label");
    if (discLabelEl && disc > 0) {
      var discTitle = "Discount";
      var capps = c.cart_level_discount_applications || [];
      if (capps.length && capps[0].title) discTitle = capps[0].title;
      else {
        for (var di = 0; di < items.length; di++) {
          var la = items[di].line_level_discount_allocations || [];
          if (la.length && la[0].discount_application && la[0].discount_application.title) { discTitle = la[0].discount_application.title; break; }
        }
      }
      discLabelEl.textContent = discTitle;
    }

    if (perksEl) {
      // One compact line to keep the footer small: "Free shipping · Saving $X"
      var bits = [];
      if (cnt >= 1) bits.push("Free shipping");
      if (disc > 0) bits.push("Saving <strong>" + fmt(disc) + "</strong>");
      perksEl.innerHTML = bits.length
        ? '<div class="cart-perk on"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg> ' + bits.join(" &middot; ") + "</div>"
        : "";
    }

    // Header cart badge
    [].forEach.call(document.querySelectorAll(".cart-count, [data-cart-count]"), function (el) {
      el.textContent = cnt; el.classList.toggle("has-items", cnt > 0);
    });
    var checkout = drawer.querySelector(".cart-checkout");
    if (checkout) checkout.classList.toggle("is-disabled", !items.length);
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add("open"); backdrop.classList.add("open");
    drawer.setAttribute("aria-hidden", "false"); root.style.overflow = "hidden";
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove("open"); backdrop.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true"); root.style.overflow = "";
  }
  var root = document.documentElement;

  function init() {
    build();

    // Header cart icon → open drawer instead of navigating to /cart
    [].forEach.call(document.querySelectorAll(".cart-btn, [data-cart-open]"), function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); fetchCart().then(open); });
    });

    // Product add-to-cart → AJAX add, then open drawer (keeps Seal's selling_plan)
    var form = document.getElementById("qea-product-form");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"]');
        if (btn) { btn.setAttribute("aria-busy", "true"); btn.disabled = true; }
        fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } })
          .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
          .then(function () { return fetchCart(); })
          .then(function () { open(); if (btn) { btn.removeAttribute("aria-busy"); btn.disabled = false; } })
          .catch(function () { if (btn) { btn.removeAttribute("aria-busy"); btn.disabled = false; } form.submit(); });
      });
    }

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
    fetchCart(); // set initial badge count
  }

  window.QeaCart = { open: function () { fetchCart().then(open); }, close: close, refresh: fetchCart };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* ============================================================
   One-time purchase link (below the buy button). Adds the variant
   with NO selling_plan (= one-time price), then opens the cart.
   ============================================================ */
(function () {
  "use strict";
  var link = document.querySelector("[data-onetime]");
  if (!link) return;
  link.addEventListener("click", function (e) {
    e.preventDefault();
    var form = document.getElementById("qea-product-form");
    var sel = form && form.querySelector('select[name="id"], input[name="id"]');
    var variant = sel && sel.value;
    if (!variant) return;
    if (link.getAttribute("aria-busy") === "true") return;
    link.setAttribute("aria-busy", "true");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function () {
        link.removeAttribute("aria-busy");
        if (window.QeaCart && window.QeaCart.open) window.QeaCart.open();
        else window.location.href = "/cart";
      })
      .catch(function () { link.removeAttribute("aria-busy"); window.location.href = "/cart"; });
  });
})();

/* ============================================================
   Offer countdown timer (above the buy box). Per-visitor rolling
   timer stored in localStorage — NOT a real deadline. To make it a
   real fixed deadline, set data-deadline="2026-08-01T00:00:00" on the element.
   ============================================================ */
(function () {
  "use strict";
  var el = document.querySelector("[data-countdown]"); // config lives on the product-page timer (optional)
  var fixed = el && el.getAttribute("data-deadline");
  var mins = (el && parseInt(el.getAttribute("data-minutes"), 10)) || 5;
  var deadline;
  if (fixed) {
    deadline = Date.parse(fixed);
  } else {
    var KEY = "qea_offer_deadline_v4";
    try {
      deadline = parseInt(localStorage.getItem(KEY), 10);
      if (!deadline || deadline < Date.now()) { deadline = Date.now() + mins * 60000; localStorage.setItem(KEY, String(deadline)); }
    } catch (e) { deadline = Date.now() + mins * 60000; }
  }
  window.QEA_OFFER_DEADLINE = deadline; // so the cart drawer's timer counts from the same moment
  function fmt(rem) {
    if (rem < 0) rem = 0;
    var h = Math.floor(rem / 3600000), m = Math.floor((rem % 3600000) / 60000), s = Math.floor((rem % 60000) / 1000);
    return (h > 0 ? (h < 10 ? "0" : "") + h + ":" : "") + (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s;
  }
  function tick() {
    var rem = deadline - Date.now();
    var txt = fmt(rem);
    // update every timer on the page (product page + cart drawer), including ones added later
    [].forEach.call(document.querySelectorAll("[data-oc-time]"), function (o) { o.textContent = txt; });
    if (rem <= 0) clearInterval(iv);
  }
  tick();
  var iv = setInterval(tick, 1000);
})();

/* ============================================================
   Default-select the $1 plan (Seal group 1) in the buy box.
   Retries while Seal renders; clicks it once so it's pre-selected.
   ============================================================ */
(function () {
  "use strict";
  var form = document.getElementById("qea-product-form");
  if (!form) return;
  var tries = 0, done = false;
  var iv = setInterval(function () {
    tries++;
    var opt = form.querySelector('.sls-option-container[data-selling-plan-group="1"]');
    if (opt) {
      if (!opt.classList.contains("sls-active")) {
        var hit = opt.querySelector('input[type="radio"]') || opt.querySelector('[role="radio"]') || opt;
        hit.click();
      }
      done = true;
    }
    if (done || tries > 24) clearInterval(iv);
  }, 250);
})();

/* ============================================================
   Trim Seal's clutter so Add to cart is reachable faster:
   hide the "Subscription details" heading and the long recurring-
   purchase consent paragraph. (Shopify still collects subscription
   consent on the checkout page.) Matches by text so it works no
   matter which classes the live Seal widget uses. Re-runs while
   Seal hydrates. Guards: only leaf-most matching elements, capped
   text length, so it never hides a big container by accident.
   ============================================================ */
(function () {
  "use strict";
  function hideByText(re, maxLen, clipBox) {
    var els = document.querySelectorAll(
      "#MainContent h1, #MainContent h2, #MainContent h3, #MainContent h4, #MainContent h5, #MainContent h6, #MainContent p, #MainContent span, #MainContent div, #MainContent label, #MainContent legend, #MainContent small"
    );
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest(".offer-pick") || el.closest(".gtee-card") || el.closest(".site-footer")) continue; // never touch our own copy
      var t = (el.textContent || "").replace(/\s+/g, " ").trim();
      if (!t || !re.test(t) || (maxLen && t.length > maxLen)) continue;
      var childHit = false;
      for (var j = 0; j < el.children.length; j++) {
        if (re.test((el.children[j].textContent || "").replace(/\s+/g, " "))) { childHit = true; break; }
      }
      if (childHit) continue; // a child matches too → this is a wrapper, skip it
      el.setAttribute("hidden", "");
      el.style.display = "none";
      if (clipBox) {
        // Also collapse the empty Seal box that held this heading (clip, so any
        // controls inside stay clickable). Never touch our own summary / buttons.
        var box = el.closest('[class*="sealsubs"], [class*="sls-"]');
        if (box && !box.querySelector(".offer-pick, .buy-cta, [name='add']")) {
          box.style.cssText += ";position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;margin:-1px!important;padding:0!important;border:0!important;";
        }
      }
    }
  }
  function scrub() {
    hideByText(/subscription details/i, 40, true);
    hideByText(/deferred,?\s*subscription,?\s*or recurring/i, 700, false);
  }
  scrub();
  var n = 0, iv = setInterval(function () { scrub(); if (++n > 16) clearInterval(iv); }, 300);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scrub);
})();

/* ============================================================
   Two-option summary (.offer-pick). Each row selects the matching
   HIDDEN Seal option so the real product form drives checkout:
     • "sub"  → the $1 selling plan (Seal group 1)
     • "once" → Seal's one-time purchase option ([role="button"])
   Add to cart then submits whatever Seal has selected (subscription
   keeps its selling_plan; one-time adds with none). Falls back to a
   direct one-time add if Seal's one-time option isn't found.
   ============================================================ */
(function () {
  "use strict";
  var pick = document.querySelector("[data-offer-pick]");
  var form = document.getElementById("qea-product-form");
  if (!pick || !form) return;
  var onceNoSealOption = false;

  function sealSelect(sel) {
    var o = form.querySelector(sel);
    if (!o) return false;
    var hit = o.querySelector('input[type="radio"]') || o.querySelector('[role="radio"]') || o;
    hit.click();
    return true;
  }

  function setActive(mode) {
    [].forEach.call(pick.querySelectorAll(".offer-row"), function (r) {
      var on = r.getAttribute("data-offer") === mode;
      r.classList.toggle("is-active", on);
      r.setAttribute("aria-checked", on ? "true" : "false");
    });
    if (mode === "once") {
      onceNoSealOption = !sealSelect('.sls-option-container[role="button"]');
    } else {
      onceNoSealOption = false;
      sealSelect('.sls-option-container[data-selling-plan-group="1"]');
    }
  }

  [].forEach.call(pick.querySelectorAll(".offer-row"), function (r) {
    r.addEventListener("click", function () { setActive(r.getAttribute("data-offer")); });
  });

  // Fallback only: if Seal exposes no one-time option, add the variant directly (no selling_plan).
  form.addEventListener("submit", function (e) {
    if (!onceNoSealOption) return; // subscription OR Seal handled one-time → let the normal handler run
    e.preventDefault();
    e.stopImmediatePropagation();
    var sel = form.querySelector('select[name="id"], input[name="id"]');
    var variant = sel && sel.value;
    if (!variant) { form.submit(); return; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (x) { throw x; }); return r.json(); })
      .then(function () { if (window.QeaCart && window.QeaCart.open) window.QeaCart.open(); else window.location.href = "/cart"; })
      .catch(function () { window.location.href = "/cart"; });
  }, true); // capture: runs before the cart-drawer submit handler
})();

/* ============================================================
   30-Day Money-Back Guarantee modal (opened from the footer link)
   ============================================================ */
(function () {
  "use strict";
  var modal = document.getElementById("gteeModal");
  if (!modal) return;
  var root = document.documentElement;
  function open(e) { if (e) e.preventDefault(); modal.classList.add("open"); modal.setAttribute("aria-hidden", "false"); root.style.overflow = "hidden"; }
  function close() { modal.classList.remove("open"); modal.setAttribute("aria-hidden", "true"); root.style.overflow = ""; }
  [].forEach.call(document.querySelectorAll("[data-guarantee-open]"), function (b) { b.addEventListener("click", open); });
  [].forEach.call(modal.querySelectorAll("[data-guarantee-close]"), function (b) { b.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("open")) close(); });
})();

/* ============================================================
   Subscription Terms modal (opened from the footer link)
   ============================================================ */
(function () {
  "use strict";
  var modal = document.getElementById("subsModal");
  if (!modal) return;
  var root = document.documentElement;
  function open(e) { if (e) e.preventDefault(); modal.classList.add("open"); modal.setAttribute("aria-hidden", "false"); root.style.overflow = "hidden"; }
  function close() { modal.classList.remove("open"); modal.setAttribute("aria-hidden", "true"); root.style.overflow = ""; }
  // Delegated so it also catches the "Terms" link rendered dynamically inside the cart drawer.
  document.addEventListener("click", function (e) { if (e.target.closest("[data-subs-open]")) open(e); });
  [].forEach.call(modal.querySelectorAll("[data-subs-close]"), function (b) { b.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("open")) close(); });
})();

/* ============================================================
   Welcome popup — 20% off email capture (WELCOME20)
   ============================================================ */
(function () {
  "use strict";
  var pop = document.getElementById("qeaPop");
  if (!pop) return;

  var KEY = "qea_pop_seen_v2";
  // Once per visitor: the flag persists (no expiry).
  function seen() { try { return !!localStorage.getItem(KEY); } catch (e) { return false; } }
  function mark() { try { localStorage.setItem(KEY, "1"); } catch (e) {} }

  var opened = false, benefitPick = "";
  var docEl = document.documentElement;

  function step(n) {
    [].forEach.call(pop.querySelectorAll(".qea-pop-step"), function (s) {
      s.hidden = s.getAttribute("data-step") !== n;
    });
  }
  // force=true re-opens even if already seen (used by the side tab)
  function open(force) {
    if (!force && (opened || seen())) return;
    opened = true;
    step("1");
    pop.classList.add("open");
    pop.setAttribute("aria-hidden", "false");
    docEl.style.overflow = "hidden";
    mark();
  }
  function close() {
    pop.classList.remove("open");
    pop.setAttribute("aria-hidden", "true");
    docEl.style.overflow = "";
  }

  // Side tab re-opens the popup anytime (bypasses the once-per-visitor guard)
  var tab = document.getElementById("qeaPopTab");
  if (tab) tab.addEventListener("click", function () { open(true); });

  [].forEach.call(pop.querySelectorAll("[data-pop-close]"), function (b) { b.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && pop.classList.contains("open")) close(); });

  // Step 1 → 2 : record the chosen benefit
  [].forEach.call(pop.querySelectorAll(".qea-pop-opt"), function (b) {
    b.addEventListener("click", function () {
      benefitPick = b.getAttribute("data-benefit") || "";
      step("2");
      var inp = pop.querySelector(".qea-pop-input");
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    });
  });

  // Step 2 submit → (optional) capture answer + email to the webhook, then reveal the code
  var form = pop.querySelector(".qea-pop-form");
  if (form) form.addEventListener("submit", function (e) {
    e.preventDefault();
    var inp = form.querySelector('input[type="email"]');
    var email = (inp.value || "").trim();
    if (!email || email.indexOf("@") < 1 || email.indexOf(".") < 0) { inp.focus(); inp.style.borderColor = "var(--oxblood)"; return; }
    var hook = pop.getAttribute("data-webhook");
    if (hook) {
      try {
        fetch(hook, {
          method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify({ email: email, benefit: benefitPick, code: "WELCOME20", source: "welcome-popup", page: location.pathname })
        });
      } catch (err) {}
    }
    step("3");
  });

  // Copy the code
  var copyBtn = pop.querySelector("[data-pop-copy]");
  if (copyBtn) copyBtn.addEventListener("click", function () {
    var code = "WELCOME20";
    var done = function () { copyBtn.textContent = "Copied"; setTimeout(function () { copyBtn.textContent = "Copy"; }, 1600); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
    else done();
  });

  // Triggers: ~10s delay OR exit-intent (desktop) OR scroll-to-top intent (mobile). Once per visitor (tab re-opens).
  var delay = (parseInt(pop.getAttribute("data-delay"), 10) || 10) * 1000;
  setTimeout(open, delay);
  document.addEventListener("mouseout", function (e) {
    if (!e.relatedTarget && e.clientY <= 0) open();
  });
  var lastY = window.scrollY || 0;
  window.addEventListener("scroll", function () {
    var y = window.scrollY;
    if (y < lastY - 48 && y < 320) open();
    lastY = y;
  }, { passive: true });
})();

/* ============================================================
   Sticky mobile buy bar — show once the buy form scrolls off,
   tap to jump straight down to the real product form.
   ============================================================ */
(function () {
  "use strict";
  var bar = document.getElementById("qeaBuybar");
  if (!bar) return;
  var form = document.getElementById("qea-product-form") || document.querySelector(".buy-form");
  var cta = bar.querySelector(".buybar-cta") || bar.querySelector("a, button");
  // On the product page, tap smooth-scrolls to the real form instead of jumping/reloading.
  if (cta && form) cta.addEventListener("click", function (ev) {
    ev.preventDefault();
    form.scrollIntoView({ behavior: "smooth", block: "center" });
  });
  if (form && "IntersectionObserver" in window) {
    // Show the bar whenever the buy form is off-screen; hide it when the form is in view.
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle("show", !e.isIntersecting);
      bar.setAttribute("aria-hidden", e.isIntersecting ? "true" : "false");
    }, { threshold: 0 });
    io.observe(form);
  } else {
    // No product form on this page (e.g. homepage) — show after a short scroll; the link navigates.
    window.addEventListener("scroll", function () {
      var on = (window.scrollY || 0) > 640;
      bar.classList.toggle("show", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
    }, { passive: true });
  }
})();

/* ============================================================
   Video testimonials — tap a poster card to play the clip
   (with sound) in a lightbox. Videos load only on tap.
   ============================================================ */
(function () {
  "use strict";
  var cards = document.querySelectorAll(".vcard");
  var lb = document.getElementById("vlightbox");
  if (!cards.length || !lb) return;
  var vid = document.getElementById("vlightboxVid");
  if (lb.parentNode !== document.body) document.body.appendChild(lb); // escape any clipping
  function open(src) {
    vid.src = src;
    lb.classList.add("open");
    lb.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    var p = vid.play(); if (p && p.catch) p.catch(function () {});
  }
  function close() {
    lb.classList.remove("open");
    lb.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    vid.pause(); vid.removeAttribute("src"); vid.load();
  }
  [].forEach.call(cards, function (c) {
    c.addEventListener("click", function () {
      var s = c.getAttribute("data-video"); if (s) open(s);
    });
  });
  lb.addEventListener("click", function (e) { if (e.target === lb) close(); });
  var x = lb.querySelector(".vlightbox-close"); if (x) x.addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && lb.classList.contains("open")) close();
  });
})();

/* ============================================================
   Video reviews carousel — arrow buttons + progress bar so it
   scrolls on both phone and desktop.
   ============================================================ */
(function () {
  "use strict";
  var track = document.querySelector(".vreviews-track");
  if (!track) return;
  var prev = document.querySelector(".vrev-prev");
  var next = document.querySelector(".vrev-next");
  var fill = document.querySelector(".vreviews-bar-fill");
  function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
  function update() {
    var max = maxScroll();
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max - 2;
    if (fill) {
      var ratio = track.clientWidth / track.scrollWidth;         // visible fraction
      var w = Math.max(0.12, Math.min(1, ratio));
      fill.style.width = (w * 100) + "%";
      var travel = (1 - w) * 100;                                // % the thumb can move
      var pos = max > 0 ? (track.scrollLeft / max) : 0;
      fill.style.transform = "translateX(" + (pos * travel / w) + "%)";
    }
  }
  // Direct scrollLeft assignment (reliable); CSS scroll-behavior:smooth animates it in real browsers.
  function step(dir) {
    var max = maxScroll();
    track.scrollLeft = Math.max(0, Math.min(max, track.scrollLeft + dir * track.clientWidth * 0.85));
    update();
  }
  if (prev) prev.addEventListener("click", function () { step(-1); });
  if (next) next.addEventListener("click", function () { step(1); });
  track.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();

/* ============================================================
   Hero video background — one seamless loop (monk → run → pour)
   ============================================================ */
(function () {
  "use strict";
  var vid = document.getElementById("heroVid");
  if (!vid) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    vid.removeAttribute("autoplay"); try { vid.pause(); } catch (e) {}
    return; // reduced motion: the monk-still poster stays
  }
  vid.muted = true;
  var p = vid.play();
  if (p && p.catch) p.catch(function () {});
})();

/* ============================================================
   Review hub — "Load more reviews"
   ============================================================ */
(function () {
  "use strict";
  var btn = document.getElementById("revMore");
  var grid = document.getElementById("revGrid");
  if (!btn || !grid) return;
  if (!grid.querySelector(".is-more")) { btn.setAttribute("hidden", ""); return; }
  btn.addEventListener("click", function () {
    grid.classList.add("show-more");
    btn.setAttribute("hidden", "");
    var all = document.getElementById("revAll");
    if (all) all.removeAttribute("hidden");
  });
})();

/* ============================================================
   Write-a-review modal (submits to owner for moderation)
   ============================================================ */
(function () {
  "use strict";
  var modal = document.getElementById("revModal");
  var openBtn = document.getElementById("revWrite");
  if (!modal || !openBtn) return;
  var root = document.documentElement;
  if (modal.parentNode !== document.body) document.body.appendChild(modal); // escape any clipping/containing ancestor
  function open() { modal.classList.add("open"); modal.setAttribute("aria-hidden", "false"); root.style.overflow = "hidden"; }
  function close() { modal.classList.remove("open"); modal.setAttribute("aria-hidden", "true"); root.style.overflow = ""; }
  openBtn.addEventListener("click", open);
  [].forEach.call(modal.querySelectorAll("[data-rev-close]"), function (b) { b.addEventListener("click", close); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && modal.classList.contains("open")) close(); });

  var stars = [].slice.call(modal.querySelectorAll(".rev-star"));
  var ratingInput = document.getElementById("revRating");
  function setRating(v) { ratingInput.value = v; stars.forEach(function (s) { s.classList.toggle("on", parseInt(s.getAttribute("data-v"), 10) <= v); }); }
  stars.forEach(function (s) { s.addEventListener("click", function () { setRating(parseInt(s.getAttribute("data-v"), 10)); }); });

  function step(n) { [].forEach.call(modal.querySelectorAll(".rev-step"), function (s) { s.hidden = s.getAttribute("data-rev-step") !== n; }); }
  var form = document.getElementById("revForm");
  if (form) form.addEventListener("submit", function (e) {
    e.preventDefault();
    var nameEl = document.getElementById("revName"), textEl = document.getElementById("revText");
    var name = (nameEl.value || "").trim(), text = (textEl.value || "").trim();
    if (!name) { nameEl.focus(); nameEl.style.borderColor = "var(--oxblood)"; return; }
    if (!text) { textEl.focus(); textEl.style.borderColor = "var(--oxblood)"; return; }
    var hook = modal.getAttribute("data-webhook");
    if (hook) {
      try {
        fetch(hook, { method: "POST", mode: "no-cors", headers: { "Content-Type": "text/plain;charset=utf-8" },
          body: JSON.stringify({ source: "review", rating: ratingInput.value, name: name,
            title: (document.getElementById("revTitle").value || "").trim(), review: text, page: location.pathname }) });
      } catch (err) {}
    }
    step("2");
  });
})();
